import shoppableImage from '../helpers/ShoppableImage';

// export default (settings, module_name, index) => {
export default (settings) => {
  const caption = settings.image.caption
    ? `<div class="Module-FullWidthImage__caption">${settings.image.caption}</div>`
    : '';

  const html = `
    ${shoppableImage(settings.image)}
    ${caption}
  `;
  return html;
};
